module.exports = __webpack_public_path__ + "media/images/new_home/5-kevin-edwards-c5db08c0c76cd1d3a7f567aeef62812c.png";